<div class="barcode-dialog">
  <div class="barcode-dialog-title">Please scan barcode</div>
  <div class="barcode-box">
    <ngx-barcode
      [bc-value]="data.barcode"
      [bc-line-color]="lineColor"
      [bc-width]="width"
      [bc-height]="height"
      [bc-display-value]="displayValue"
      [bc-font-options]="fontOptions"
      [bc-font]="font"
      [bc-text-align]="textAlign"
      [bc-text-position]="textPosition"
      [bc-text-margin]="textMargin"
      [bc-font-size]="fontSize"
      [bc-background]="background"
      [bc-margin]="margin"
      [bc-margin-top]="marginTop"
      [bc-margin-bottom]="marginBottom"
      [bc-margin-left]="marginLeft"
      [bc-margin-right]="marginRight">
    </ngx-barcode>
  </div>
  <div class="center-button">
    <button mat-stroked-button color="primary" (click)="onNoClick()">X</button>
  </div>
</div>
